import { Dialog } from "primereact/dialog";
import { Accordion, AccordionTab } from "primereact/accordion";
import { MassMailSendingCountForm } from "./massMailSendingCountSetting/MassMailSendingCountForm";
import { MassMailExperienceSettingForm } from "./massMailExperienceSetting/MassMailExperienceSettingForm";
import { MassMailInhouseCompanySettingForm } from "./massMailInhouseCompanySetting/MassMailInhouseCompanySettingForm";
import { MassMailServerSettingForm } from "./massMailServerSetting/MassMailServerSettingForm";
import { NextMassMailWaitTimeSettingForm } from "./nextMassMailWaitTimeSetting/NextMassMailWaitTimeSettingForm";
import { MassMailRequestServingSettingForm } from "./massMailRequestServingSetting/MassMailRequestServingSettingForm";



interface Iprops {
  open: boolean;
  hideDialog: () => void;
  toast: any;
  reload: boolean;
  setReload: (is: boolean) => void;
}

export const Form = (props: Iprops) => {


  // useEffect(() => {
  //   reset(props.singleData);
  // }, [props.singleData]);

  const onHide = () => {
    props.hideDialog();
  };




  return (
    <>
      <Dialog visible={props.open} style={{ width: "80vw" }} header="Add Template" modal className="p-fluid" onHide={onHide} maximizable >
        <Accordion multiple activeIndex={[0]}>
          {/* <AccordionTab header="Email Sending Count Setting">
            <MassMailSendingCountForm reload={props.reload} setReload={props.setReload} toast={props.toast} />
          </AccordionTab> */}
          {/* <AccordionTab header="Experience Months Count Setting">
            <MassMailExperienceSettingForm reload={props.reload} setReload={props.setReload} toast={props.toast} />
          </AccordionTab> */}
          <AccordionTab header="Next Mass Mail  Request Waiting Time Setting">
            <NextMassMailWaitTimeSettingForm reload={props.reload} setReload={props.setReload} toast={props.toast} />
          </AccordionTab>
          <AccordionTab header="Company Wise Max Sending Mail  Count Setting">
            <MassMailInhouseCompanySettingForm reload={props.reload} setReload={props.setReload} toast={props.toast} />
          </AccordionTab>
          <AccordionTab header="Mass Mail Server Setting">
            <MassMailServerSettingForm reload={props.reload} setReload={props.setReload} toast={props.toast} />
          </AccordionTab>
          <AccordionTab header="Next Mass Mail  Request Serving Setting">
            <MassMailRequestServingSettingForm reload={props.reload} setReload={props.setReload} toast={props.toast} />
          </AccordionTab>
        </Accordion>
      </Dialog>
    </>
  );
};
